import React, { Component } from "react";
import * as d3 from "d3";
import "../style.css";
import Table from "../Table/index";
import { getReportDownload } from "../JSONCSV";
import EmptyState from "../../../../../../../assets/svg/evNoData.svg";
import moment from "moment";
const colors = ["#5eaaa8", "#5bcc5b", "#ffc478", "#f05f5f"];

class BatteryTemp extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewIdx: 0,
    };
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.isExpanded == "ct003") {
      this.renderPie(300, 300);
    }
  }

  getPieData(data) {
    let pie = {};
    for (let [key, value] in Object.entries(data)) {
      pie[key] = data[key][1];
    }
    return pie;
  }
  renderPie(refWidth = 200, refHeight = 200) {
    var width = refWidth;
    var height = refHeight;
    var margin = 30;

    var radius = Math.min(width, height) / 2 - margin;

    var svg = d3.select(this.refs.batteryEV);
    svg.selectAll("svg").remove();
    var svg = d3
      .select(this.refs.batteryEV)
      .append("svg")
      .attr("width", width)
      .attr("height", height)
      .append("g")
      .attr("transform", "translate(" + width / 2 + "," + height / 2 + ")");

    var data = this.getPieData(
      this.props.data ? this.props.data.distribution : {}
    );

    // set the color scale
    var color = d3
      .scaleOrdinal()
      .domain(["0", "1", "2", "3"])
      .range(["#5eaaa8", "#5bcc5b", "#ffc478", "#f05f5f"]);

    var pie = d3
      .pie()
      .value(function (d) {
        return d.value;
      })
      .sort(function (a, b) {
        return d3.ascending(a.key, b.key);
      }); // This make sure that group order remains the same in the pie chart
    const data_ready = pie(Object.entries(data));

    // map to data
    var u = svg.selectAll("path").data(data_ready);

    // Build the pie chart: Basically, each part of the pie is a path that we build using the arc function.
    u.enter()
      .append("path")
      .merge(u)
      .transition()
      .duration(1000)
      .attr("d", d3.arc().innerRadius(0).outerRadius(radius))
      .attr("fill", function (d) {
        return color(d.data.key);
      })
      .attr("stroke", "white")
      .style("stroke-width", "2px")
      .style("opacity", 1);
  }

  componentDidMount() {
    this.renderPie();
  }
  renderLegends() {
    let data = this.props.data ? this.props.data.distribution : {};
    let legends = [];
    for (let [key, value] in Object.entries(data)) {
      legends.push(
        <li key={key}>
          <div className="firstElem">
            <i className="fa fa-car-battery" style={{ color: colors[key] }}></i>
            {/* <div style={{backgroundColor:colors[key]}}></div> */}
            <span>{this.props.data.distribution[key][0]} °C</span>
          </div>
          <span className="secElem">
            {this.props.data.distribution[key][1]}
          </span>
        </li>
      );
    }
    return legends;
  }
  getCSVName() {
    let auth = window.auth;
    let date = moment().format("DD-MM-YYYY_Hmm");
    return auth.userinfo.username + "_Battery_Temp_" + date;
  }

  searchReport(key) {
    var filter, table, tr, td, i, txtValue;
    filter = key.toUpperCase();
    table = document.getElementById("fleetBatteryTable");
    tr = table.getElementsByTagName("tr");
    for (i = 0; i < tr.length; i++) {
      td = tr[i].getElementsByTagName("td")[0];
      if (td) {
        txtValue = td.textContent || td.innerText;
        if (txtValue.toUpperCase().indexOf(filter) > -1) {
          tr[i].style.display = "";
        } else {
          tr[i].style.display = "none";
        }
      }
    }
  }
  minimizeWidget(id) {
    this.props.setExpand(id);
    this.renderPie(200, 200);
  }

  render() {
    return (
      <div
        className={
          "widgetLayout " +
          (this.props.isExpanded === "ct003" ? "expandedWidget " : "")
        }
        style={{ opacity: this.props.isLive ? 1 : "0.1" }}
      >
        <div className="header">
          <div>Fleet Battery Temperature</div>

          <div
            className="rightIcons"
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: 50,
              alignItems: "center",
            }}
          >
            <i
              onClick={() =>
                getReportDownload(
                  this.props.data.history,
                  this.props.heads,
                  this.getCSVName()
                )
              }
              className="fa fa-download"
            ></i>
            {this.props.isExpanded == "ct003" ? (
              <i
                onClick={() => this.minimizeWidget("ct003")}
                className="fa fa-window-minimize"
              ></i>
            ) : (
              <i
                onClick={() => this.props.setExpand("ct003")}
                className="fa fa-window-maximize"
              ></i>
            )}
          </div>
        </div>
        {this.props.data.history.length > 0 ? (
          <div
            style={{
              display: "flex",
              justifyContent:
                this.state.viewIdx === 1 ? "space-between" : "flex-end",
              alignItems: "center",
            }}
          >
            {this.state.viewIdx === 1 ? (
              <div
                className="searchBox"
                style={{
                  marginLeft: 12,
                  marginTop: 9,
                  width: this.props.isExpanded == "ct003" ? 315 : 160,
                }}
              >
                <input
                  type="text"
                  placeholder="search"
                  style={{
                    padding: "3px 8px",
                    borderRadius: 15,
                    width: "100%",
                    border: "1px solid #b1b1b1",
                    fontSize: 11,
                    color: "#4c4a4a",
                  }}
                  onChange={(e) => this.searchReport(e.target.value)}
                />
              </div>
            ) : null}

            <div className="topAction">
              <ul>
                <li
                  onClick={() =>
                    this.setState({ viewIdx: 0 }, () => {
                      this.renderPie(
                        this.props.isExpanded == "ct003" ? 300 : 200,
                        this.props.isExpanded == "ct003" ? 300 : 200
                      );
                    })
                  }
                  className={this.state.viewIdx === 0 ? "active" : ""}
                >
                  Chart
                </li>
                <li
                  onClick={() => this.setState({ viewIdx: 1 })}
                  className={this.state.viewIdx === 1 ? "active" : ""}
                >
                  Table
                </li>
              </ul>
            </div>
          </div>
        ) : null}
        {this.state.viewIdx === 0 ? (
          <div className="widgetbody">
            {this.props.data.history.length === 0 ? (
              <img style={{ width: 200 }} src={EmptyState} />
            ) : (
              <div className="widgetContainer">
                <div
                  id="pieEV"
                  ref="batteryEV"
                  style={{
                    width: "50%",
                    display: "flex",
                    justifyContent: "center",
                  }}
                ></div>
                <div
                  className="legends"
                  style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "flex-end",
                  }}
                >
                  <ul
                    style={{
                      width: this.props.isExpanded == "ct003" ? "65%" : "100%",
                    }}
                  >
                    {this.renderLegends()}
                  </ul>
                </div>
              </div>
            )}
          </div>
        ) : (
          <div className="tableView">
            <Table
              updateData={this.props.updateData}
              ref={(ref) => {
                this.child = ref;
              }}
              data={this.props.data.history}
              heads={this.props.heads}
              metric="batterytemp"
              colorOn="temp"
              tableId="fleetBatteryTable"
            />
          </div>
        )}
      </div>
    );
  }
}

export default BatteryTemp;
